import { render, staticRenderFns } from "./userPortalList.vue?vue&type=template&id=fff23f74&scoped=true"
import script from "./userPortalList.vue?vue&type=script&lang=js"
export * from "./userPortalList.vue?vue&type=script&lang=js"
import style0 from "./userPortalList.vue?vue&type=style&index=0&id=fff23f74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff23f74",
  null
  
)

export default component.exports